module.exports = __webpack_public_path__ + "static/img/salon.977f952.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/salon.jpg
// module id = 36
// module chunks = 0